(document.addEventListener("DOMContentLoaded", ()=>{

    let currentSelectedProds = []
    let currentSelectedDesign;
    const firstStage = document.getElementById("inital-stage");
    const finalStage = document.getElementById("final-stage");
    let design_list = []; 
    function get_designs(){
        var design_list_url = `https://oddballs-data--development.gadget.app/apps/oddballs-data/metaobject?handle=design_list_with_extras`;
        var design_url = `https://oddballs-data--development.gadget.app/apps/oddballs-data/metaobject?handle=design`;

        var params1 = { type: 'GET', url: design_list_url, dataType: 'html' };
        var params2 = { type: 'GET', url: design_url, dataType: 'html' };

            Promise.all([$.ajax(params1), $.ajax(params2)])
            .then(([response1, response2]) => {
            
                const jsonData = JSON.parse(response1);
                const designValue = jsonData[0].node.fields.find(field => field.key === 'list').value;
                const designArray = JSON.parse(designValue);

                const jsonData2 = JSON.parse(response2);
                for(design_id of designArray){
                    for(node of jsonData2){
                    if(node.node.id == design_id){
                        design_list.push(node)
                    }
                    }
                }
            })
    
    }
    get_designs();

    const removeChoice = (localCount) => {
        let temp = choiceList.filter((item)=>{
            return item.count != localCount
        });
        choiceList = temp;
        updateChoices();
    }

    const updateChoices = () =>{
        const choicesEle = document.getElementById("selected-pairs")
        const choicesEleWrapper = document.getElementById("selected-pairs-wrapper")
        let count = 0;
        const backButton = document.querySelector(".ppj-back-button")
        choicesEle.innerHTML = "";
        if(choiceList.length >= 1){
            backButton.classList.remove("hidden")
        }else{
            backButton.classList.add("hidden")
        }
        choiceList.forEach((choice)=>{
            count += 1;
            const choiceWrapper = document.createElement("div");
            choiceWrapper.className = "text-xs selected-size rounded-md text-center p-1 relative"
            choiceWrapper.dataset.count = count;
            const remove = document.createElement("div");
            remove.className="absolute top-0 right-0 rounded-full flex items-center justify-center w-6  h-6 bg-magenta-500 text-white ppj-remove";
            remove.innerHTML = "x";
            remove.addEventListener("click", ()=>{removeChoice(choice.count)});
            const optionDiv = document.createElement("div");
            optionDiv.innerHTML = choice.category;
            const typeDiv = document.createElement("div");
            typeDiv.innerHTML = choice.type;
            const sizeDiv = document.createElement("div");
            sizeDiv.innerHTML = choice.size;
            choiceWrapper.append(optionDiv, typeDiv, sizeDiv, remove);
            choicesEle.insertBefore(choiceWrapper, choicesEle.firstChild);
        })
        if(potentialPair){
            count += 1;
            const choiceWrapper = document.createElement("div");
            choiceWrapper.className = "text-xs selected-size rounded-md text-center p-1"
            const optionDiv = document.createElement("div");
            optionDiv.innerHTML = potentialPair.category;
            const typeDiv = document.createElement("div");
            typeDiv.innerHTML = potentialPair.type;
            const sizeDiv = document.createElement("div");
            sizeDiv.innerHTML = potentialPair.size;
            choiceWrapper.append(optionDiv, typeDiv, sizeDiv);
            choicesEle.insertBefore(choiceWrapper, choicesEle.firstChild);
        }else{
            const addAnother = document.createElement("div");
        addAnother.className = " border border-dotted border-gray-300 rounded-md h-full w-full px-2 flex text-center justify-center items-center pointer-events-none";
        addAnother.style.minHeight = "58px";
        const addEle = document.createElement("div");
        addEle.classList.add("options-selected");
        addEle.innerHTML = "add another";
        selectEle = document.createElement("div");
        selectEle.classList.add("options-missing");
        selectEle.innerHTML = "select size";
        addAnother.append(addEle,selectEle);
        choicesEle.insertBefore(addAnother, choicesEle.firstChild);
            // const currentlySelecting = document.createElement("div");
            // currentlySelecting.classList.add("animate-mt");
            // currentlySelecting.style.width = "84px";
            // currentlySelecting.classList.add("h-full");
            // choicesEle.insertBefore(currentlySelecting, choicesEle.firstChild);
        }
        if(count >=1){
            choicesEleWrapper.classList.remove("hidden")
        }
        if(count >= 2){
            document.querySelector(".selection-inner-wrapper").classList.add("option-selected")
        }else{
            document.querySelector(".selection-inner-wrapper").classList.remove("option-selected")
        }
        
    }

    const currentFormLoc = document.querySelector("#current-form-loc");
    let currentFormEle = document.getElementById("loading-form");
    let choiceList = [];
    let potentialPair;
    let addPotentialPair = () =>{
        const checkedInputs = Array.from(document.querySelectorAll(".current-form input:checked"));
        const categoryInput = checkedInputs.find((input)=>{
            return input.classList.contains("category-input")
        })
        const typeInput = checkedInputs.find((input)=>{
            return input.classList.contains("type-input")
        })
        const sizeInput = checkedInputs.find((input)=>{
            return input.classList.contains("size-input")
        })
        if(categoryInput?.classList.contains("kids-category-input")){
            if(sizeInput?.classList.contains("adult-size-input")){
                potentialPair = false;
                updateChoices();
                return
            }
        }
        if(categoryInput?.classList.contains("adult-category-input")){
            if(sizeInput?.classList.contains("kids-size-input")){
                potentialPair = false;
                updateChoices();
                return
            }
        }
        let category = (categoryInput?.value)
        let type  = (typeInput?.value)
        let size = (sizeInput?.value)
        const selection = {
            category,
            type,
            size
        }
        if(category && type && size){

            potentialPair = selection;
            updateChoices();
        }else{
            potentialPair = false;
            updateChoices();
        }
    }
    let globCount = 0;
    const addPair = () =>{
        globCount += 1;
        const checkedInputs = Array.from(document.querySelectorAll(".current-form input:checked"));
        const categoryInput = checkedInputs.find((input)=>{
            return input.classList.contains("category-input")
        })
        const typeInput = checkedInputs.find((input)=>{
            return input.classList.contains("type-input")
        })
        const sizeInput = checkedInputs.find((input)=>{
            return input.classList.contains("size-input")
        })
        let category = (categoryInput?.value)
        let type  = (typeInput?.value)
        let size = (sizeInput?.value)
        if(!category) return
        if(!type) return
        if(!size) return
        const selection = {
            category,
            type,
            size,
            count: globCount 
        }
        choiceList.push(selection);
        updateChoices()

    }

    const swapChoice = (choice) =>{
          choice.isSwapped = !choice.isSwapped;
        updateFinalUi();
    }
    const setPriceEle = document.getElementById("set-total-price")
    const setCompPriceEle = document.getElementById("set-comp-price")

    const buildItem = (prod, choice, hasDifferentStyles) => {
        const price = Number(prod.variants[0].price);
        const compare = Number(prod.variants[0].compare_at_price);

        const prodPrice = price % 1 === 0 ? price : price.toFixed(2);
        const compPrice = compare % 1 === 0 ? compare : compare.toFixed(2);

        const wrapper = document.createElement("div");
        wrapper.className = "final-prod-wrapper flex flex-col  justify-between shadow-lg";
        const  imgWrapper = document.createElement("div");
        imgWrapper.classList.add("relative")
        const imgPlaceholder = document.createElement("div");
        imgPlaceholder.style.width="100%";
        imgPlaceholder.style.paddingTop = "100%"
        const imgEle = document.createElement("img");
        imgEle.src = prod.image.replace(".jpg","_200x.jpg").replace(".png","_300x.png");
        imgEle.className= "w-full absolute top-0 left-0";
        const swapEle = document.createElement("div")
        swapEle.classList.add("swap-div")
              if(hasDifferentStyles){
                const innerSwapDiv = document.createElement("div");
                innerSwapDiv.innerHTML = !prod.tags.includes("button-up-pyjamas") ? "Swap to button up" : "Swap back to original"
                innerSwapDiv.className = "bg-cyan-500 text-white px-2 py-1 text-xs text-center flex items-center justify-center"
                innerSwapDiv.style.height="36px";
                swapEle.appendChild(innerSwapDiv); 
                innerSwapDiv.addEventListener("click", ()=>{
                    swapChoice(choice)
                })
            }
            imgWrapper.append(imgPlaceholder,imgEle, swapEle)
            const infoWrapper = document.createElement("div");
            infoWrapper.classList.add("px-2")
            const title = choice.category + " " + choice.type
            const titleEle = document.createElement("div");
            titleEle.innerHTML = title;
            titleEle.classList = "font-bold uppercase";
            const sizeEle = document.createElement("div");
            sizeEle.innerHTML = choice.size;
            const priceWrapperEle = document.createElement("div");
            priceWrapperEle.className = "text-xs gap-1 flex"
            const priceIntro = document.createElement("span");
            priceIntro.innerHTML = "Price: ";
            const priceEle = document.createElement("span");
            priceEle.className  = "text-magenta";
            priceEle.innerHTML = "£" + prodPrice;
            const compPriceEle = document.createElement("del");
            compPriceEle.innerHTML = compPrice == prodPrice? "" : "£" + compPrice;
            priceWrapperEle.append(priceIntro, priceEle, compPriceEle);
            infoWrapper.append(titleEle, sizeEle, priceWrapperEle);
            wrapper.append(imgWrapper, infoWrapper);
            return wrapper;

    }
    const finalProdWrapper = document.getElementById("selected-prods")
    const updateFinalUi = () => {
        const currentDesignEle = document.getElementById("current-design-name");
        currentDesignEle.innerHTML = currentSelectedDesign;

        if(!hasRegular){
            regularDesignLoc.classList.remove("grid-cols-6")
            regularDesignLoc.innerHTML = "Sorry we have no regular print matches"
        }else{
            regularDesignLoc.classList.add("grid-cols-6")
        }
        if(!hasChristmas){
            christmasDesignLoc.classList.remove("grid-cols-6")
            christmasDesignLoc.innerHTML = "Sorry we have no christmas print matches"
        }else{
            christmasDesignLoc.classList.add("grid-cols-6")
        }
        if(!hasPartnerships){
            partnershipsDesignLoc.classList.remove("grid-cols-6")
            partnershipsDesignLoc.innerHTML = "Sorry we have no partnerships print matches"
        }else{
            partnershipsDesignLoc.classList.add("grid-cols-6")
        }

        const categories = ["mens", "womens", "kids"];
        const lengths = ["short", "long"];
        let totalPrice = 0;
        let totalCompPrice = 0;
        let count = 0
        finalProdWrapper.innerHTML = "";
        choiceList.forEach((choice)=>{
            const prods = currentSelectedProds.filter(
                (prod) => prod.category === choice.category && prod.length === choice.type
            );
            const hasDifferentStyles = prods.some((prod)=>{
                return prod.isButtonUp
            }) &&   prods.some((prod)=>{
                return !prod.isButtonUp
            })
            let prodToUse = !hasDifferentStyles || !choice.isSwapped ? prods.find((prod)=>{
                return !prod.isButtonUp || prods[0]
            }) : prods.find((prod)=>{
                return prod.isButtonUp 
            }) || prods[0]
            totalPrice += Number(prodToUse.variants[0].price)
            totalCompPrice += Number(prodToUse.variants[0].compare_at_price)
            const gridItem = buildItem(prodToUse, choice, hasDifferentStyles);
            finalProdWrapper.appendChild(gridItem)
            count += 1;
            
        })

        
        if(count <= 2){
            document.getElementById("selected-prods").classList.add("justify-center")
        }else{
            document.getElementById("selected-prods").classList.remove("justify-center")
            
        }

        const finalProdPrice = totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(2);
        const finalCompPrice = totalCompPrice % 1 === 0 ? totalCompPrice : totalCompPrice.toFixed(2);
            setPriceEle.innerHTML = "£" + finalProdPrice;
            setCompPriceEle.innerHTML = totalPrice == finalCompPrice ? "" : "£" + finalCompPrice;
        };
    
    const regularDesignLoc = document.getElementById("regular-prints-loc");
    const christmasDesignLoc = document.getElementById("christmas-prints-loc");
    const partnershipsDesignLoc = document.getElementById("partnerships-prints-loc");

    const highlightSelectedDesign = (ele) =>{
        const options = document.querySelectorAll(".option-wrapper");
        options.forEach(option => {
            option.classList.remove("active-print")
        });
        ele.classList.add("active-print");
    }

    let hasChristmas = false;
    let hasRegular = false;
    let hasPartnerships = false;
    let createOption = (matchingDesign,prods, index) => {
        const imageUrl = matchingDesign.node.fields.find((field)=>{return field.key=="img_url"}).value
        const designName = matchingDesign.node.fields.find((field)=>{return field.key=="tag"}).value.replace("design-","").replace(/-/g, " ");
        const optionEle = document.createElement('div');
        optionEle.className="w-full rounded-md option-wrapper relative";
        optionEle.setAttribute("data-cro-feature-clicked",`print-clicked-${designName}`)
        if(index ==0){
            optionEle.classList.add("active-print")
        }
        const image = document.createElement("img");
        image.src = imageUrl
        image.className = "w-full absolute top-0 h-full rounded-md left-0";
        const placeholder = document.createElement("div");
        placeholder.style.width="100%"
        placeholder.style.paddingTop="100%"
        optionEle.appendChild(image)
        optionEle.appendChild(placeholder);
        const isChristmasDesign = prods.some((prod)=>{           
            return prod.isChristmas
        })
        const isPartnerships = prods.some((prod)=>{
            return prod.isPartnerships;
        })
        if (isPartnerships){
            hasPartnerships = true
            partnershipsDesignLoc.appendChild(optionEle)
        }else if(isChristmasDesign){
            hasChristmas = true;
            christmasDesignLoc.appendChild(optionEle)
        } else{
            hasRegular = true;
            regularDesignLoc.appendChild(optionEle)
        }
        
        optionEle.addEventListener("click", ()=>{
            currentSelectedProds = prods;
            currentSelectedDesign = designName;
            highlightSelectedDesign(optionEle);
            updateFinalUi();
        })

    }
    const createOptions = (data) =>{
        let prodFound = false;
        hasChristmas = false;
        hasRegular = false;
        hasPartnerships = false;
        partnershipsDesignLoc. innerHTML = "";
        christmasDesignLoc.innerHTML = "";
        regularDesignLoc.innerHTML = "";
        Object.entries(data).forEach(([prodDesign, prods], index) => {
            const matchingDesign = design_list.find((design)=>{
                return design.node.fields.find((field)=>{return field.key=="tag"}).value == prodDesign.replace("design-", "");
            })
            if(matchingDesign){
                if(!prodFound){
                    currentSelectedDesign = matchingDesign.node.fields.find((field)=>{return field.key=="tag"}).value.replace("-", " ")
                    currentSelectedProds = prods
                    prodFound = true;
                }
                createOption(matchingDesign,prods, index)
            }
        });
        updateFinalUi();

    } 
    const getMatches = async () => {
          try {
            const res = await fetch("https://oddballs-data--development.gadget.app/apps/oddballs-data/matching-pyjamas", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ choices: choiceList })
            });

            if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
            }

            const data = await res.json();
            console.log(data)
            

            createOptions(data)
            console.log("scrolling to top")
            window.scrollTo({ top: 0, behavior: "smooth" });
            document.getElementById("final-stage-loading").classList.add("hidden")
            document.querySelector(".final-stage-info").classList.remove("hidden")

        } catch (err) {
            console.error("Error sending choices:", err);
        }
    
    }
    const deleteForm = () => {
     
        currentFormEle.remove();
    }
    const createForm = () => {
        const formTemplate = document.querySelector('.section-template');
        const formClone = formTemplate.cloneNode(true);
        formClone.classList.add("current-form")
        currentFormEle = formClone;
        formClone.style.display="block";
        formClone.classList.remove("section-template");
        const cloneInputs = Array.from(formClone.querySelectorAll("input"))
        cloneInputs.forEach((input)=>{
            input.name = input.name + "-for-realsies";
        })
        formClone.setAttribute("data-cro-feature-viewed", `ppj-stage-${globCount}`);

        currentFormLoc.appendChild(formClone)
        const formNumber = choiceList.length
        const numberEle = document.querySelector(".pair-number");
        if(formNumber == 0){
            numberEle.innerHTML = "1st"
        }else if (formNumber == 1){
            numberEle.innerHTML = "2nd"
        }else if (formNumber == 2){
            numberEle.innerHTML = "3rd"
        }else{
            numberEle.innerHTML = (formNumber + 1) + "th";
        }
        updateChoices();
        
    }
    const addPairjamasToCart = () => {
        document.getElementById("form-loc").innerHTML = "";
        let prodsToAdd = []
            choiceList.forEach((choice) => {
                let matchingProd = currentSelectedProds.find((prod) => {
                    if (prod.category !== choice.category) return false;
                    if (prod.variants[0].title !== choice.size) return false;
                    if(prod.length !== choice.type) return false
                    if (choice.isSwapped && !prod.isButtonUp) {
                        const hasAlternate = currentSelectedProds.some(
                            (p) =>
                                p.category === choice.category &&
                                p.variants[0].title === choice.size &&
                                p.isButtonUp
                        );
                        if (hasAlternate) return false;
                    }
                    return true; 
                });
                prodsToAdd.push(matchingProd || null);
            });
            for(product of prodsToAdd){
              const form = document.createElement('form');
                form.method = 'post';
                form.action = '/cart/add';
                form.id = `product-form-${product.id}`;
                form.acceptCharset = 'UTF-8';
                form.classList.add('flex', 'h-full', 'flex-col', 'border-t', 'bg-white', 'product-form', "hidden");
                form.enctype = 'multipart/form-data';
                form.setAttribute('data-product-id', product.id);
                form.setAttribute('novalidate', 'novalidate');
                form.setAttribute('data-type', 'add-to-cart-form');
                const hiddenInputs = [
                    { name: 'form_type', value: 'product' },
                    { name: 'utf8', value: '✓' },
                    { name: 'id', value: product.variants[0].id, class: 'product-selected-variant-id', 'data-product-id': product.id },
                    { name: 'quantity', value: '1', class: 'product__quantity', id: 'qty-template--16162885926973__main' },
                    { name: 'attributes[_freeshp]', value: '' },
                    { name: 'properties[_co]', value: 'b' },
                    { name: 'product-id', value: product.id },
                    { name: 'properties[_Perfect Pairjamas]', value: product.id }
                ];
                hiddenInputs.forEach(inputData => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = inputData.name;
                    input.value = inputData.value;
                    if (inputData.class) input.classList.add(inputData.class);
                    if (inputData.id) input.id = inputData.id;
                    if (inputData['data-product-id']) input.setAttribute('data-product-id', inputData['data-product-id']);
                   
                    form.appendChild(input);
                });
                  const atcButton = document.createElement('button');
                  atcButton.type = 'submit';
                  atcButton.classList.add('add-to-cart-button', 'hidden');
                  form.appendChild(atcButton);
                  const prodData = document.createElement('input');
                  prodData.classList.add("js-prod-data")
                  prodData.value = JSON.stringify(product);
                  prodData.setAttribute("type", "hidden");
                  prodData.id = "product-json-" + product.id;
                  form.append(prodData);
                  form.addEventListener('submit', function(event) {
                      event.preventDefault();
                  });
 
        document.getElementById("form-loc").append(form);
       
      }
 
      addFormsToCart(0)
 
    }
 
    async function addFormsToCart(index) {
          const forms = document.querySelectorAll('#form-loc .product-form');
          for (let form of forms) {
              const addToCartButton = form.querySelector('.add-to-cart-button');
              addToCartButton.click();
              await ppAddToCart(form, form.querySelector('.product-selected-variant-id').value);
          }
    //    document.querySelector('#add-match-to-cart').innerHTML = "Add To Cart";
    }
 
function ppAddToCart(form, currentVariant) {
    return new Promise((resolve, reject) => {
        const productData = JSON.parse(form.querySelector('.js-prod-data').value);
 
        const formData = new FormData(form);
        const dataString = new URLSearchParams(formData).toString();
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            body: dataString,
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return response.json().then((json) => {
                    throw new Error(json.description || 'Failed to add to cart');
                });
            }
        })
        .then(cartItem => {
            const event = new CustomEvent('itemAddedToCart', {
                detail: {
                    variant: currentVariant,
                    product: productData,
                    formData: formData,
                },
            });
            document.dispatchEvent(event);
            const quantityDiv = document.getElementById("cart-items-number");
            const resetRevent = new CustomEvent('revertToCart');
            document.dispatchEvent(resetRevent);
 
            const cartevent = new CustomEvent('updateCart');
            document.dispatchEvent(cartevent);
 
            resolve(cartItem); // Resolve the promise when item is successfully added
        })
        .catch(error => {
            console.error('ATC: Error adding to cart:', error);
            reject(error); // Reject the promise if there's an error
        });
    });
}
const popPair = () =>{
    choiceList.pop()
}
const goBack = () =>{
    potentialPair = false;
    choiceList.pop();
    deleteForm();
    createForm();
    updateChoices();
}

    document.addEventListener("click", (e)=>{
        if(e.target.closest("#perfect-pair-jamas-back")){
            popPair();
            updateChoices();
            firstStage.classList.remove("hidden")
            finalStage.classList.add("hidden")
            document.getElementById("final-stage-loading").classList.remove("hidden")
            document.querySelector(".final-stage-info").classList.add("hidden")

        }
        if(e.target.closest(".ppj-back-button")){
            goBack();
        }
        if(e.target.closest("#add-pairjamas-to-cart")){
            addPairjamasToCart()
        }
        if(e.target.closest(".size-option") || e.target.closest(".type-choice") || e.target.closest(".selection-slider")){
            setTimeout(()=>{

                addPotentialPair();
            },1)
        }
        if(e.target.closest(".add-another-cta")){
               potentialPair = false;
            addPair()
            deleteForm()
            createForm()
        }
        if(e.target.closest(".find-pairs-cta")){
            firstStage.classList.add("hidden")
            finalStage.setAttribute("data-cro-feature-viewed", `ppj-final-stage`)
            finalStage.classList.remove("hidden")
            
            addPair()
            // deleteForm()
            getMatches()
        }
    })
    deleteForm();
    createForm();
}))